import React from 'react';
import 'date-fns';
//import parseISO from 'date-fns/parseISO'
import misc from "../../utils/misc";

import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
//import enLocale from "date-fns/locale/en-US";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers'; //DatePicker


// https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table

class kDateField extends React.Component {
    constructor(props) {
        super(props);
        let d = misc.dateHelper.parseDate(this.props.value);
        var tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate()); // + 1);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.state = {
            selectedDate: d,
            minDate: tomorrow
        };
        this.dateExtras = this.props.dateExtras;
        this.readOnly = this.props.readOnly;        
    }

    handleDateChange = (date) => {
        this.setState({ selectedDate: date });
        // inform parent
        if (this.props.onChange)
            this.props.onChange(this.props.id, date);
    };


    disabledDates = (date) => {
        let ret = !this.dateExtras.centerDays.includes(date.getDay());
        if (ret === false) { // still enabled.
            let fmtDate = misc.dateHelper.format(date);
            ret = this.dateExtras.disabledDates.includes(fmtDate);
        }
        return ret;
    }

    render() {
        //  variant="outlined"
        return (
            <Grid container justifyContent="space-around">
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker fullWidth                        
                        variant="inline"
                        inputVariant="outlined"
                        shouldDisableDate={this.disabledDates}
                        format="EEEE, d MMMM"
                        readOnly={this.readOnly}
                        id={this.props.id}
                        label="Start Date"
                        value={this.state.selectedDate}
                        minDate={this.state.minDate}
                        onChange={this.handleDateChange}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                        InputProps={{ readOnly: this.readOnly }}
                    />
                </MuiPickersUtilsProvider>
            </Grid>
        )
    }
}

export default kDateField;
